import * as React from "react";
import { Box, Card, CardContent, Container, Divider, Typography } from "@mui/material";

const TermsOfService = () => {
  const effectiveDate = "Sep 25, 2025";

  return (
    <Box component="main">
      <Box sx={{ py: { xs: 5, md: 7 }, borderBottom: "1px solid", borderColor: "divider", bgcolor: "background.paper" }}>
        <Container maxWidth="lg">
          <Typography variant="h4" component="h1" fontWeight={900} gutterBottom>
            Terms of Service
          </Typography>
          <Typography color="text.secondary">
            Effective date: {effectiveDate}
          </Typography>
        </Container>
      </Box>

      <Container maxWidth="lg" sx={{ py: { xs: 4, md: 6 } }}>
        <Card variant="outlined" sx={{ borderRadius: 3 }}>
          <CardContent>
            <Typography variant="h6" fontWeight={900} gutterBottom>
              Acceptance of terms
            </Typography>
            <Typography variant="body2" color="text.secondary" paragraph>
              By accessing or using this website, you agree to these Terms of Service. If you do not agree,
              please do not use the site.
            </Typography>

            <Divider sx={{ my: 2 }} />

            <Typography variant="h6" fontWeight={900} gutterBottom>
              Website use
            </Typography>
            <Typography variant="body2" color="text.secondary" paragraph>
              You may use this site for lawful purposes only. You agree not to misuse the site, attempt
              unauthorized access, or interfere with site operation.
            </Typography>

            <Divider sx={{ my: 2 }} />

            <Typography variant="h6" fontWeight={900} gutterBottom>
              Intellectual property
            </Typography>
            <Typography variant="body2" color="text.secondary" paragraph>
              All content on this website (text, graphics, logos, and design) is owned by or licensed to
              BhamuIntelli Systems LLP unless otherwise stated. You may not reproduce or redistribute
              content without permission.
            </Typography>

            <Divider sx={{ my: 2 }} />

            <Typography variant="h6" fontWeight={900} gutterBottom>
              Disclaimers
            </Typography>
            <Typography variant="body2" color="text.secondary" paragraph>
              This website is provided “as is” and “as available.” We do not guarantee that the site will
              be uninterrupted or error-free. Content is for general information and may change without notice.
            </Typography>

            <Divider sx={{ my: 2 }} />

            <Typography variant="h6" fontWeight={900} gutterBottom>
              Limitation of liability
            </Typography>
            <Typography variant="body2" color="text.secondary" paragraph>
              To the maximum extent permitted by law, BhamuIntelli Systems LLP shall not be liable for any
              indirect, incidental, special, consequential, or punitive damages arising from your use of the site.
            </Typography>

            <Divider sx={{ my: 2 }} />

            <Typography variant="h6" fontWeight={900} gutterBottom>
              Third-party links
            </Typography>
            <Typography variant="body2" color="text.secondary" paragraph>
              This site may contain links to third-party websites. We are not responsible for the content,
              policies, or practices of third-party sites.
            </Typography>

            <Divider sx={{ my: 2 }} />

            <Typography variant="h6" fontWeight={900} gutterBottom>
              Governing law
            </Typography>
            <Typography variant="body2" color="text.secondary" paragraph>
              These terms are governed by the laws applicable in Maharashtra, India, without regard to conflict
              of law principles.
            </Typography>

            <Divider sx={{ my: 2 }} />

            <Typography variant="h6" fontWeight={900} gutterBottom>
              Contact
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Email: bis9.llp@gmail.com, neha@studytunnel.com • Phone: +91 9096272737
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
              Registered Address: SNO 5/2/1 Daffodils, Gulmohar City, Kharadi, Viman Nagar, Pune 411014,
              Maharashtra, India
            </Typography>
          </CardContent>
        </Card>
      </Container>
    </Box>
  );
};

export default TermsOfService;
